// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"skip-links_wrapper__KmAGg","container":"skip-links_container__47e5n"};